import { Injectable } from '@angular/core';
import { ApiService } from '@app/core/services/api.service';

@Injectable({
  providedIn: 'root'
})
export class NotificationActivityService {

  constructor(private readonly apiService: ApiService) { }

  getNotificaitionActivities(user) {
    return this.apiService.get('NotificationActivity/notification/' + user);
  }

  removeNotificationActivies(user){
    return this.apiService.delete('NotificationActivity/' + user);
  }

  updateNotifiedStatus(user){
    return this.apiService.post('NotificationActivity/Notify/' + user, {});
  }

  notifyCompletedEvents(body: object) {
    return this.apiService.post('CalendarItem/NotifyCompletedWorkflowEvents', body);
  }
}
